import ExcelJS from 'exceljs'

export default ExcelJS